module.exports = __webpack_public_path__ + "static/media/call.3801d1c8.gif";